import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import AdminNavbar from "./components/admins/AdminNavbar";
import Profile from "./components/users/Profile";
import Login from "./components/users/Login";
import LogOut from "./components/users/LogOut";
import ProtectedRoute from "./Auth/ProtectedRoutes";
import Register from "./components/users/Register";
import Products from "./components/Products";
import NotFound from "./components/NotFound";
import SingleProduct from "./components/SingleProduct";
import Cart from "./components/users/Cart";
import ProtectedAdminRoutes from "./Auth/ProtectedAdminRoutes";
import ProductsList from "./components/admins/ProductsList";
import AdminLogin from "./components/admins/AdminLogin";
import AdminLogOut from "./components/admins/AdminLogOut";
import ProductUpload from "./components/admins/ProductUpload";
import CheckOut from "./components/users/CheckOut";
import Success from "./components/Success";
import Failure from "./components/Failure";
import Orders from "./components/users/Orders";
import AdminOrders from "./components/admins/AdminOrders";
import { lazy, Suspense } from "react";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsAndConditions";
import RefundPolicy from "./components/Refund-policy";
import Shipping from "./components/Shipping";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import ForgetPassword from "./components/users/ForgetPassword";
const Footer = lazy(() => import("./components/Footer"));
export default function AppRoutes() {
  const location = useLocation();
  const adminRoutes = [
    "/admin/login",
    "/admin/products-list",
    "/admin/product-upload",
    "/admin/orders",
  ];
  const isAdminRoute = adminRoutes.some((path) =>
    location.pathname.startsWith(path)
  );
  return (
    <>
      {isAdminRoute ? <AdminNavbar /> : <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:productID" element={<SingleProduct />} />
        <Route path="/users/login" element={<Login />} />
        <Route path="/users/register" element={<Register />} />
        <Route path="/users/forgot-password" element={<ForgetPassword/>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/logout" element={<LogOut />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/users/cart" element={<Cart />} />
          <Route path="/users/profile" element={<Profile />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/success" element={<Success />} />
          <Route path="/failure" element={<Failure />} />
          <Route path="/orders" element={<Orders/>} />
        </Route>
        <Route path="/admin/logout" element={<AdminLogOut />} />
        <Route element={<ProtectedAdminRoutes />}>
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/products-list" element={<ProductsList />} />
          <Route path="/admin/product-upload" element={<ProductUpload />} />
        </Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms-conditions" element={<TermsOfService/>} />
        <Route path="/refund-policy" element={<RefundPolicy/>} />
        <Route path="/shipping-delivery" element={<Shipping/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Suspense fallback={<div>Loading Footer...</div>}>
        <Footer />
      </Suspense>
    </>
  );
}
